import Button from "@/v2-backoffice-client/components/button"

function ErrorFallback() {
  return (
    <div className="flex items-center justify-center flex-1 bg-background">
      <div className="max-w-md w-full space-y-8 p-8 bg-card rounded-lg shadow-lg border">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-foreground">
            Something went wrong
          </h2>
          <p className="mt-4 text-center text-sm text-muted-foreground">
            An unexpected error occurred. Please refresh the page and try again.
          </p>
        </div>
        <div className="flex justify-center">
          <Button
            onClick={() => {
              window.location.reload()
            }}
          >
            Refresh Page
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ErrorFallback
